import React from 'react';
import CapitalFrame from '@di-shared/features/capital/CapitalFrame';

interface CapitalFullPageProps {
  vin: string;
}

export default function CapitalFullPage({vin}: CapitalFullPageProps) {
  const queryString = new URLSearchParams(window.location.search);
  const to = decodeURIComponent(queryString.get('to') || '');

  return (
    <CapitalFrame
      vin={vin}
      to={to}
      isInitMounted={true}
    />
  );
}
